<template>
  <div class="v-question" :class="{small: small}">
    <v-popover offset="5" trigger="hover">
      <!-- This will be the popover target (for the events and position) -->
      <div class="quest" />
      <!-- This will be the content of the popover -->
      <template slot="popover">
        <p class="v-question__content">
          {{ content }}
        </p>
      </template>
    </v-popover>
  </div>
</template>
<script>
import {VPopover} from 'v-tooltip';
import 'STYLES/tooltip.css';
export default {
  name: 'VQuestion',
  components: {
    VPopover,
  },
  props: {
    content: {
      type: String,
    },
    small: {
      type: Boolean,
    },
  },
};
</script>
<style scoped>
.v-question {
  display: inline-block;
  height: 15px;
  width: 15px;
  margin: 0 0 0 5px;
  cursor: pointer;
  position: relative;
}
.v-question.small {
  height: 13px;
  width: 13px;
  margin-left: 0;
}
.v-question.small .quest {
  height: 13px;
  width: 13px;
  margin-bottom: -2px;
}
.quest {
  height: 15px;
  width: 15px;
  background-image: url(~IMAGES/icons/quest.svg);
  background-size: contain;
}
.v-question__content {
  max-width: 350px;
  font-size: 14px;
}
@media (--viewport-planshet) {
  .v-question {
    height: 20px;
    width: 20px;
    margin-left: 10px;
  }
  .quest {
    height: 20px;
    width: 20px;
  }
}
</style>
